var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"downlo"},[_c('div',[_vm._v("Fazendo Download...")]),_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"mr-1"},[_vm._v("\n      Caso o download não tenha iniciado sozinho, por favor\n    ")]),_c('div',{staticClass:"clique",on:{"click":_vm.download}},[_vm._v("Clique aqui")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }